import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from '../../../../../assets/styles/componentStyles/voiceAgentStyles/voiceAgent.module.scss';
import textstyles from "../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import { Autocomplete, Chip, Grid, TextField, useMediaQuery } from '@mui/material'
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import agent from '../../../../../services/api';
import GlobalButton from '../../../../../components/utility/globalButton/button';
import PersonIcon from '@mui/icons-material/Person';
import CallEndIcon from '@mui/icons-material/CallEnd';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import whatsappIcon from '../../../../../assets/Whatsapp.svg';
import globalStyles from '../../../../../assets/styles/global.module.scss'
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import CloseIcon from '@mui/icons-material/Close';
import { useVoiceCallStore } from '../../../../../store/voiceCallStore';
import { getDefaultPeerConnectionConfig, waitForIceGatheringComplete } from '../../../../../utils/webrtcIceGathering';
import { useGenericStore } from '../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow'
import {
    getBusinessPhoneLabel,
    getEndUserDisplayName,
    getEndUserPhoneNumber,
} from '../../../../../utils/voiceCallDetails'
import { getTemplateDetails, getWhatsappTemplateTypeResponse } from '../../../../../models/axiosModel';
import { isTemplateTypeCallPermissionRequest, templateTypeColor } from '../../../../../components/dashboard/channels/global/whatsapp/templates/utils';
import { useNavigate } from 'react-router-dom';
import { formatPhoneNumber } from '../../../utils';
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';

const VoiceAIPopup = () => {
    const navigate = useNavigate();
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    type MicPermission = 'idle' | 'granted' | 'denied';
    const [flagAllowedToCall, setFlagAllowedToCall] = useState<boolean | null>(null)
    const [micPermission, setMicPermission] = useState<MicPermission>('idle');
    const [isCheckingMicPermission, setIsCheckingMicPermission] = useState(true);

    // const [isCalling, setIsCalling] = useState(false);
    const [isRequestingMic, setIsRequestingMic] = useState(false);
    const [isMicMuted, setIsMicMuted] = useState(false);
    const [isStartingCall, setIsStartingCall] = useState(false);
    // const [callDuration, setCallDuration] = useState(0); // Call duration in seconds
    // const [isCallConnected, setIsCallConnected] = useState(false);

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    // WebRTC refs
    const localStreamRef = useRef<MediaStream | null>(null);
    const peerConnectionRef = useRef<RTCPeerConnection | null>(null);
    const remoteAudioElementRef = useRef<HTMLAudioElement | null>(null);
    const isCallConnectedRef = useRef<boolean>(false);
    const ringingAudioRef = useRef<HTMLAudioElement | null>(null);
    const ringingAudioContextRef = useRef<AudioContext | null>(null);
    const ringingOscillatorRef = useRef<OscillatorNode | null>(null);
    const ringingGainRef = useRef<GainNode | null>(null);
    const stateCheckIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
    const isStartingCallRef = useRef(false);
    const [whatsappTemplateTypes, setWhatsappTemplateTypes] = useState<getWhatsappTemplateTypeResponse[] | null>(null);
    const [callRequestTemplateList, setCallRequestTemplateList] = useState<getTemplateDetails[] | null>(null);
    const [selectedCallRequestTemplate, setSelectedCallRequestTemplate] = useState<getTemplateDetails | null>(null);
    // const callStartTimeRef = useRef<number | null>(null);

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
        largeScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1600px)'),
    }

    const { setFlagVoiceCallPopup, callingWabaDetails, callingPersonDetails, voiceCallDetails, isCallConnected, setIsCallConnected, setVoiceCallId,
        voiceCallId, isCalling, setIsCalling, callDuration, startCallTimer, timerIntervalTimeout, setTimerIntervalTimeout, stopCallTimer
     } = useVoiceCallStore(useShallow((state) => ({
        setFlagVoiceCallPopup: state.setFlagVoiceCallPopup,
        callingWabaDetails: state.callingWabaDetails,
        callingPersonDetails: state.callingPersonDetails,
        voiceCallDetails: state.voiceCallDetails,
        isCallConnected: state.isCallConnected,
        setIsCallConnected: state.setIsCallConnected,
        setVoiceCallId: state.setVoiceCallId,
        voiceCallId: state.voiceCallId,
        isCalling: state.isCalling,
        setIsCalling: state.setIsCalling,
        callDuration: state.callDuration,
        startCallTimer: state.startCallTimer,
        timerIntervalTimeout: state.timerIntervalTimeout,
        setTimerIntervalTimeout: state.setTimerIntervalTimeout,
        stopCallTimer: state.stopCallTimer
    })))

    const { currentActiveChatbotThread } = useRuleBasedInboxStore(useShallow((state) => ({
        currentActiveChatbotThread: state.currentActiveChatbotThread
    })))

    const findPersonDetail = (field: string) => {
        const personMetaData = callingPersonDetails?.thread_metadata
        const fieldLower = field.toLowerCase();
        switch (fieldLower) {
            case "phone":
                return personMetaData?.find((data: any) => data?.metadata_type_name == "phone_number")?.metadata_value
            case "name":
                return personMetaData?.find((data: any) => data?.metadata_type_name == "name")?.metadata_value
            default:
                return personMetaData?.find((data: any) => data?.metadata_type_name == "name")?.metadata_value
        } 
    }

    const getCallerPhone = () => {
        return getEndUserPhoneNumber(voiceCallDetails, findPersonDetail('phone'));
    };

    const getFormattedCallerPhone = () => {
        const phone = getCallerPhone();
        return phone ? formatPhoneNumber(phone) : null;
    };

    const getCallerDisplayName = () => {
        const name = getEndUserDisplayName(voiceCallDetails, findPersonDetail('name'));
        if (name === 'Unknown Caller') {
            return getFormattedCallerPhone() || 'Unknown Contact';
        }
        return name;
    };

    const getCallingFromLabel = () => {
        return getBusinessPhoneLabel(voiceCallDetails, callingWabaDetails, 'outbound');
    };

    const shouldShowPersonIcon = () => {
        const name = voiceCallDetails?.end_user?.name || findPersonDetail('name');
        const displayName = getCallerDisplayName();
        if (!name || name.toUpperCase() === 'UNKNOWN') {
            return true;
        }
        return /^[\d+]+$/.test(displayName.replace(/[\s-]/g, ''));
    };

    const getCallerInitial = () => {
        if (shouldShowPersonIcon()) {
            return null;
        }
        const displayName = getCallerDisplayName();
        const firstChar = displayName.trim().charAt(0);
        return firstChar ? firstChar.toUpperCase() : '?';
    };

    const renderPulsingCallerAvatar = () => (
        <div className={styles.voiceCallAvatarPulseWrap}>
            <span className={`${styles.voiceCallAvatarPulseRing} ${styles.voiceCallAvatarPulseRingOne}`} aria-hidden />
            <span className={`${styles.voiceCallAvatarPulseRing} ${styles.voiceCallAvatarPulseRingTwo}`} aria-hidden />
            <div className={styles.voiceCallAvatarPulseCore}>
                {shouldShowPersonIcon() ? (
                    <PersonIcon sx={{ color: '#fff', fontSize: 34 }} />
                ) : (
                    getCallerInitial()
                )}
            </div>
        </div>
    );

    const getPopupTitle = () => {
        if (isCallConnected) return 'Voice call';
        if (isCalling) return 'Calling...';
        return 'Voice call';
    };

    const checkUserAllowedToCall = async () => {
        const metaPhoneNumber = findPersonDetail("phone") ?? "";
        const phoneNumberId = callingWabaDetails?.phone_number_id;
        const thread_id = currentActiveChatbotThread?.chatbot_user_id || "";

        if (!phoneNumberId || (!metaPhoneNumber && !thread_id)) {
            setCallRequestTemplateList([]);
            setFlagAllowedToCall(false);
            showError('Unable to start the call. Contact or business phone details are missing.')
            return;
        }

        try {
            const res = await agent.checkUserAllowedToCall.get(phoneNumberId, metaPhoneNumber, thread_id);
            if (res.status) {
                const isCallAllowed = Boolean(res?.data?.call_allowed);

                if (isCallAllowed) {
                    setWhatsappTemplateTypes(null);
                    setCallRequestTemplateList(null);
                    setSelectedCallRequestTemplate(null);
                    setFlagAllowedToCall(true);
                    return;
                }

                // Keep the preparing screen until template APIs finish, so empty-state
                // "Create Template" UI does not flash before the list response arrives.
                const allowedTemplateTypes = await getWhatsappTemplateTypes();
                if (allowedTemplateTypes?.length) {
                    const metaIntegrationWhatsappId = Number(callingPersonDetails?.meta_integration_whatsapp_id);
                    const whatsappTemplateTypeId = allowedTemplateTypes[0]?.whatsapp_template_type_id;
                    if (metaIntegrationWhatsappId && whatsappTemplateTypeId) {
                        await getCallRequestTemplateList(metaIntegrationWhatsappId, whatsappTemplateTypeId);
                    } else {
                        setCallRequestTemplateList([]);
                    }
                } else {
                    setCallRequestTemplateList([]);
                }

                setFlagAllowedToCall(false);
            } else {
                // handleError(res);
                showError(res?.error?.message ?? "Something Went Wrong")
                setFlagVoiceCallPopup(false);
            }
        } catch {
            setCallRequestTemplateList([]);
            setFlagAllowedToCall(false);
            showError('Unable to verify call permission. Please try again.')
        }
    }

    const formatCallDuration = (seconds: number): string => {
        const minutes = Math.floor(seconds / 60).toString().padStart(2, '0');
        const secs = (seconds % 60).toString().padStart(2, '0');
        return `${minutes}:${secs}`;
    };

    // Ringing sound functions
    const startRingingSound = () => {
        try {
            // Create AudioContext for generating ringing tone
            const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
            ringingAudioContextRef.current = audioContext;

            // Create oscillator for ringing tone (typical phone ring frequency)
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();

            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(440, audioContext.currentTime);

            // Create ring-ring-pause pattern (typical phone ring)
            // Pattern: ring (0.4s) - pause (0.2s) - ring (0.4s) - pause (0.2s) - long pause (2s)
            const scheduleRing = (startTime: number) => {
                // First ring
                gainNode.gain.setValueAtTime(0, startTime);
                gainNode.gain.linearRampToValueAtTime(0.15, startTime + 0.05);
                gainNode.gain.setValueAtTime(0.15, startTime + 0.35);
                gainNode.gain.linearRampToValueAtTime(0, startTime + 0.4);
                
                // First pause (0.2s)
                gainNode.gain.setValueAtTime(0, startTime + 0.6);
                
                // Second ring
                gainNode.gain.linearRampToValueAtTime(0.15, startTime + 0.65);
                gainNode.gain.setValueAtTime(0.15, startTime + 0.95);
                gainNode.gain.linearRampToValueAtTime(0, startTime + 1.0);
                
                // Long pause (2s)
                gainNode.gain.setValueAtTime(0, startTime + 3.0);
            };

            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);

            oscillator.start();
            ringingOscillatorRef.current = oscillator;
            ringingGainRef.current = gainNode;

            // Schedule initial ring
            scheduleRing(audioContext.currentTime);
            
            // Schedule repeating rings every 3 seconds
            const ringInterval = setInterval(() => {
                if (ringingAudioContextRef.current && ringingGainRef.current) {
                    scheduleRing(ringingAudioContextRef.current.currentTime);
                } else {
                    clearInterval(ringInterval);
                }
            }, 3000);

            // Store interval for cleanup
            (ringingOscillatorRef.current as any).__interval = ringInterval;

        } catch (error) {
            console.warn('Could not start ringing sound:', error);
        }
    };

    const stopRingingSound = () => {
        try {
            if (ringingOscillatorRef.current) {
                ringingOscillatorRef.current.stop();
                if ((ringingOscillatorRef.current as any).__interval) {
                    clearInterval((ringingOscillatorRef.current as any).__interval);
                }
                ringingOscillatorRef.current = null;
            }
            if (ringingGainRef.current) {
                ringingGainRef.current.disconnect();
                ringingGainRef.current = null;
            }
            if (ringingAudioContextRef.current) {
                ringingAudioContextRef.current.close().catch(() => {
                    // Ignore errors when closing audio context
                });
                ringingAudioContextRef.current = null;
            }
        } catch (error) {
            console.warn('Error stopping ringing sound:', error);
        }
    };

    const cleanupWebRTC = () => {
        stopCallTimer();
        stopRingingSound();
        isCallConnectedRef.current = false;
        setIsCallConnected(false);

        if (stateCheckIntervalRef.current) {
            clearInterval(stateCheckIntervalRef.current);
            stateCheckIntervalRef.current = null;
        }

        if (remoteAudioElementRef.current) {
            try {
                remoteAudioElementRef.current.pause();
                remoteAudioElementRef.current.srcObject = null;
                remoteAudioElementRef.current.remove();
                remoteAudioElementRef.current = null;
                // console.log('Remote audio element cleaned up');
            } catch (err) {
                console.error('Error cleaning up audio element:', err);
            }
        }

        // Close peer connection
        if (peerConnectionRef.current) {
            peerConnectionRef.current.close();
            peerConnectionRef.current = null;
            console.log('Peer connection closed');
        }

        // Stop local stream tracks
        if (localStreamRef.current) {
            localStreamRef.current.getTracks().forEach(track => {
                track.stop();
                console.log(`Stopped track: ${track.label}`);
            });
            localStreamRef.current = null;
            console.log('Local stream tracks stopped');
        }
        setIsMicMuted(false);
    };

    const toggleMicMute = () => {
        setIsMicMuted((prev) => {
            const nextMuted = !prev;
            localStreamRef.current?.getAudioTracks().forEach((track) => {
                track.enabled = !nextMuted;
            });
            return nextMuted;
        });
    };

    const endUserPhoneCall = async () => {
        const metaPhoneNumber = findPersonDetail("phone") ?? "";

        if (!voiceCallId) {
            showError('Unable to end the call. Call details are missing.')
            return;
        }

        setFlagLoading(prev => ({ ...prev, flagRoundLoader: true }));

        const payload = {
            call_id: voiceCallId,
            phone_number_id: callingWabaDetails?.phone_number_id || "",
            phone_number: metaPhoneNumber,
        };
        const res = await agent.endCall.post(payload);
        if (res.status) {
            cleanupWebRTC();
            setIsCalling(false);
            setFlagVoiceCallPopup(false);
            // Toast comes from socket COMPLETED with "Call ended by …"
        }
        else {
            handleError(res)
            showError(res?.error ?? "Something Went Wrong")
            setIsCalling(false);
            setFlagVoiceCallPopup(false);
        }
        setFlagLoading(prev => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        return () => {
            cleanupWebRTC();
        };
    }, []);

    useEffect(() => {
        return () => {
            // if (timerIntervalRef.current) {
            //     clearInterval(timerIntervalRef.current);
            // }
            if (timerIntervalTimeout) {
                clearInterval(timerIntervalTimeout);
                setTimerIntervalTimeout(null);
            }
        };
    }, []);

    const getWhatsappTemplateTypes = async (): Promise<getWhatsappTemplateTypeResponse[] | null> => {
        const response = await agent.getWhatsappTemplateType.get();
        if (response.status) {
            const allowedTemplateTypes = response.data?.filter((template: getWhatsappTemplateTypeResponse) =>
                isTemplateTypeCallPermissionRequest(template?.name)
            ) ?? [];
            setWhatsappTemplateTypes(allowedTemplateTypes);
            return allowedTemplateTypes;
        }

        setWhatsappTemplateTypes(null);
        // handleError(response);
        return null;
    }

    const getCallRequestTemplateList = async (meta_integration_whatsapp_id: number, whatsapp_template_type_id: number) => {
        const res = await agent.getWhatsappTemplateList.get(meta_integration_whatsapp_id, whatsapp_template_type_id);
        if (res.status) {
            setCallRequestTemplateList(res?.data ?? [])
        }
        else {
            setCallRequestTemplateList([])
        }
    }

    const askPermissionClick = async () => {
        const metaPhoneNumber = findPersonDetail("phone")
        setFlagLoading(prev => ({ ...prev, flagRoundLoader: true }));
        const payload = {
            phone_number_id: callingWabaDetails?.phone_number_id || "",
            template_id: selectedCallRequestTemplate?.whatsapp_template_id ?? 0,
            thread_id: currentActiveChatbotThread?.chatbot_user_id || "",
            user_wa_id: metaPhoneNumber || "",
        }
        const res = await agent.askCallPermissionUser.post(payload);
        if (res?.status) {
            const resData = res?.data;
            if (resData?.template_sent) {
                showSuccess(resData?.message)
                setFlagVoiceCallPopup(false);
            }
        }
        else {
            // handleError(res);
            showError(res?.error ?? "Something Went Wrong")
            setFlagVoiceCallPopup(false);
        }
        setFlagLoading(prev => ({ ...prev, flagRoundLoader: false }));
    }

    const getCallRequestTemplateName = (template?: getTemplateDetails | null) => {
        const templateData = template?.whatsapp_template_data?.[0];
        return templateData?.whatsapp_template_display_name
            || templateData?.whatsapp_template_name
            || 'Untitled template';
    }

    const getCallRequestTemplateCategory = (template?: getTemplateDetails | null) => {
        return template?.whatsapp_template_data?.[0]?.whatsapp_template_category_name || 'Utility';
    }

    const handleCreateCallRequestTemplateClick = () => {
        setFlagVoiceCallPopup(false);
        navigate(`/channels/viewintegration/whatsapp/templatemessages?id=${Number(callingPersonDetails?.meta_integration_whatsapp_id)}`);
    }

    const acquireMicrophoneAccess = async (showErrorOnFailure = true): Promise<boolean> => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    autoGainControl: true,
                    sampleRate: 48000,
                    channelCount: 1,
                    ...({
                        latency: 0.01,
                        googEchoCancellation: true,
                        googNoiseSuppression: true,
                        googAutoGainControl: true,
                        googHighpassFilter: true,
                        googTypingNoiseDetection: true,
                        googAudioMirroring: false
                    } as any)
                }
            });

            localStreamRef.current = stream;

            stream.getAudioTracks().forEach(track => {
                if (track.getSettings) {
                    const settings = track.getSettings();
                    console.log(`🎤 Audio track settings: sampleRate=${settings.sampleRate}, channelCount=${settings.channelCount}`);
                }

                track.applyConstraints({
                    echoCancellation: true,
                    noiseSuppression: true,
                    autoGainControl: true
                }).then(() => {
                    console.log(`✅ Audio constraints applied successfully`);
                }).catch((err) => {
                    console.warn(`⚠️ Could not apply all audio constraints: ${err.message}`);
                });
            });

            setMicPermission('granted');
            console.log('✅ Microphone access granted', 'success');
            return true;
        } catch (err: any) {
            console.error(`❌ Microphone access denied: ${err.message}`);
            setMicPermission('denied');
            if (showErrorOnFailure) {
                showError('Microphone access is required for voice calls')
            }
            return false;
        }
    };

    const checkInitialMicrophonePermission = async () => {
        try {
            if (navigator.permissions) {
                const permissionStatus = await navigator.permissions.query({ name: 'microphone' as PermissionName });
                console.log('Initial microphone permission:', permissionStatus.state);

                if (permissionStatus.state === 'granted') {
                    await acquireMicrophoneAccess(false);
                    return;
                }
                if (permissionStatus.state === 'denied') {
                    setMicPermission('denied');
                    return;
                }

                permissionStatus.onchange = () => {
                    if (permissionStatus.state === 'granted') {
                        acquireMicrophoneAccess(false);
                    } else if (permissionStatus.state === 'denied') {
                        setMicPermission('denied');
                    } else {
                        setMicPermission('idle');
                    }
                };
                return;
            }
        } catch {
            console.log('Permission API not fully supported, falling back to device enumeration');
        }

        try {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const hasMicPermission = devices.some((device) => device.kind === 'audioinput' && device.label !== '');
            if (hasMicPermission) {
                await acquireMicrophoneAccess(false);
            }
        } catch {
            console.log('Could not determine microphone permission status');
        }
    };

    const requestMicrophone = async () => {
        try {
            setIsRequestingMic(true);
            console.log('Requesting microphone access...');
            await acquireMicrophoneAccess();
        } finally {
            setIsRequestingMic(false);
        }
    };

    useEffect(() => {
        let isMounted = true;

        (async () => {
            setFlagLoading((prevState) => ({
                ...prevState,
                flagRoundLoader: true,
            }));

            try {
                await Promise.all([checkUserAllowedToCall(), checkInitialMicrophonePermission()]);
            } finally {
                if (isMounted) {
                    setIsCheckingMicPermission(false);
                    setFlagAllowedToCall((prev) => (prev === null ? false : prev));
                }
                setFlagLoading((prevState) => ({
                    ...prevState,
                    flagRoundLoader: false,
                }));
            }
        })();

        return () => {
            isMounted = false;
        };
    }, [])

    // Manage ringing sound based on calling state
    useEffect(() => {
        if (isCalling && !isCallConnected) {
            // Start ringing when calling but not connected
            startRingingSound();
        } else {
            // Stop ringing when connected or not calling
            stopRingingSound();
        }

        // Cleanup on unmount
        return () => {
            stopRingingSound();
        };
    }, [isCalling, isCallConnected]);

    const createPeerConnection = async (): Promise<RTCPeerConnection> => {
        console.log('Creating WebRTC peer connection...');

        const peerConnection = new RTCPeerConnection(getDefaultPeerConnectionConfig());
        console.log('Using default ICE server configuration.');

        // Add local audio track - CRITICAL: Ensure tracks are enabled and active
        if (localStreamRef.current) {
            localStreamRef.current.getAudioTracks().forEach(track => {
                track.enabled = !isMicMuted;
                
                // Verify track is active before adding
                if (track.readyState === 'live') {
                    peerConnection.addTrack(track, localStreamRef.current!);
                    console.log(`✅ Added audio track: ${track.label} (enabled: ${track.enabled}, muted: ${track.muted}, readyState: ${track.readyState})`);
                } else {
                    console.warn(`⚠️ Track not live: ${track.label} (readyState: ${track.readyState})`);
                }
            });

            // Verify we have active tracks
            const activeTracks = localStreamRef.current.getAudioTracks().filter(t => t.readyState === 'live');
            console.log(`📊 Active audio tracks: ${activeTracks.length}`);
            
            if (activeTracks.length === 0) {
                console.error('❌ No active audio tracks available!');
            }
        } else {
            console.error('❌ No local stream available!');
        }

        // LOG ICE ERRORS (Critical for debugging TURN)
        peerConnection.onicecandidateerror = (event) => {
            console.error("ICE Candidate Error:", event);
            console.error(`❌ ICE Error: ${event.errorCode} - ${event.errorText} (URL: ${event.url})`);
        };

        // Handle incoming remote audio tracks
        peerConnection.ontrack = (event) => {
            console.log(`📥 Received remote track: ${event.track.kind} (readyState: ${event.track.readyState})`);
            
            if (event.track.kind === 'audio') {
                handleRemoteAudioTrack(event);
            }
        };

        // ICE candidate handling with improved type detection
        type CandidateType = 'host' | 'srflx' | 'relay' | 'prflx' | 'unknown';
        let candidateCounts: Record<CandidateType, number> = { host: 0, srflx: 0, relay: 0, prflx: 0, unknown: 0 };
        peerConnection.onicecandidate = (event) => {
            if (event.candidate) {
                const candidate = event.candidate.candidate;
                // Improved detection logic
                let type: CandidateType = 'unknown';
                if (candidate.indexOf('typ relay') !== -1) type = 'relay';
                else if (candidate.indexOf('typ srflx') !== -1) type = 'srflx';
                else if (candidate.indexOf('typ prflx') !== -1) type = 'prflx';
                else if (candidate.indexOf('typ host') !== -1) type = 'host';
                
                candidateCounts[type] = (candidateCounts[type] || 0) + 1;
                console.log(`🔹 ICE candidate [${type.toUpperCase()}]: ${candidate.substring(0, 80)}...`);
            } else {
                // ICE gathering complete
                console.log(`✅ ICE gathering complete - host: ${candidateCounts.host}, srflx: ${candidateCounts.srflx}, relay: ${candidateCounts.relay}, prflx: ${candidateCounts.prflx}`);
                
                if (candidateCounts.relay === 0) {
                    console.error(`❌ CRITICAL: No TURN relay candidates found! Verify TURN server config/firewall.`);
                    console.error(`👉 Browser cannot reach TURN server: 34.9.192.80:3478`);
                } else {
                    console.log(`✅ TURN Relay candidates found! Connection should succeed.`);
                }
            }
        };

        // Monitor signaling state changes
        peerConnection.onsignalingstatechange = () => {
            console.log(`📡 Signaling state changed: ${peerConnection.signalingState}`);
        };

        // Monitor ICE gathering state
        peerConnection.onicegatheringstatechange = () => {
            console.log(`🧊 ICE gathering state changed: ${peerConnection.iceGatheringState}`);
        };

        // ICE connection state handling (more detailed than connectionState)
        peerConnection.oniceconnectionstatechange = () => {
            console.log(`🧊 ICE connection state changed: ${peerConnection.iceConnectionState}`);
            if (peerConnection.iceConnectionState === 'failed') {
                console.error(`❌ ICE connection failed! This usually means TURN server is not reachable or NAT traversal failed.`);
                showError('ICE connection failed - check TURN server configuration')
            }
            handleConnectionStateChange();
        };

        // Connection state handling - Monitor both connectionState and iceConnectionState
        const handleConnectionStateChange = () => {
            const connState = peerConnection.connectionState;
            const iceState = peerConnection.iceConnectionState;
            console.log(`📡 Connection state: ${connState}, ICE connection state: ${iceState}`);
            
            // Check if connected (either state can indicate connection)
            if (connState === 'connected' || iceState === 'connected') {
                if (!isCallConnectedRef.current) {
                    isCallConnectedRef.current = true;
                    
                    // Now, this things is handle by socket response

                    setIsCalling(true);
                    setIsCallConnected(true);
                    startCallTimer(); // Start timer when connected

                    console.log('✅ ✅ ✅ WebRTC connection established - Call timer started ✅ ✅ ✅');
                    
                    // Verify local tracks are still active
                    if (localStreamRef.current) {
                        localStreamRef.current.getAudioTracks().forEach(track => {
                            if (!track.enabled) {
                                console.warn(`⚠️ Track ${track.label} is disabled, enabling...`);
                                track.enabled = true;
                            }
                            // muted is read-only, but we can log it
                            if (track.muted) {
                                console.warn(`⚠️ Track ${track.label} is muted (read-only property - check browser settings)`);
                            }
                            console.log(`📊 Track ${track.label}: enabled=${track.enabled}, muted=${track.muted}, readyState=${track.readyState}`);
                        });
                    }
                }
            } else if (
                connState === 'disconnected' ||
                connState === 'failed' ||
                connState === 'closed' ||
                iceState === 'disconnected' ||
                iceState === 'failed' ||
                iceState === 'closed'
            ) {
                console.log('❌ WebRTC connection lost or closed');
                isCallConnectedRef.current = false;
                setIsCallConnected(false);
                setIsCalling(false);
                stopCallTimer();
            }
        };

        // Monitor connectionState
        peerConnection.onconnectionstatechange = handleConnectionStateChange;

        peerConnectionRef.current = peerConnection;
        console.log('✅ Peer connection created');
        return peerConnection;
    };

    const handleRemoteAudioTrack = (event: RTCTrackEvent) => {
        // Create or reuse audio element for remote audio
        if (!remoteAudioElementRef.current) {
            console.log('Creating new audio element for remote audio...');
            const audioElement = document.createElement('audio');
            audioElement.id = 'remote-audio-player';
            audioElement.autoplay = true;
            audioElement.volume = 1.0;
            audioElement.muted = false;
            audioElement.setAttribute('playsinline', '');
            audioElement.setAttribute('preload', 'auto');
            
            // Make it hidden but accessible
            audioElement.style.position = 'fixed';
            audioElement.style.bottom = '10px';
            audioElement.style.left = '10px';
            audioElement.style.width = '1px';
            audioElement.style.height = '1px';
            audioElement.style.opacity = '0';
            audioElement.style.pointerEvents = 'none';
            
            document.body.appendChild(audioElement);
            remoteAudioElementRef.current = audioElement;
            console.log('✅ Audio element created and added to page');
        }

        // Get audio stream from event
        let audioStream: MediaStream | null = null;
        
        if (event.streams && event.streams.length > 0) {
            audioStream = event.streams[0];
            console.log(`✅ Stream found in event (${audioStream.getAudioTracks().length} audio tracks)`);
        } else if (event.track) {
            console.log('⚠️ No streams in event, creating stream from track...');
            audioStream = new MediaStream([event.track]);
            console.log('✅ Created MediaStream from track');
        } else {
            console.error('❌ ERROR: No streams or track in event!');
            return;
        }

        // Attach stream to audio element
        if (audioStream && remoteAudioElementRef.current) {
            remoteAudioElementRef.current.srcObject = audioStream;
            console.log('✅ Stream attached to audio element');

            // Try to play audio with improved handling
            const playAudio = async () => {
                if (!remoteAudioElementRef.current) {
                    console.error('❌ No audio element available');
                    return;
                }

                try {
                    // Ensure audio element is properly configured
                    remoteAudioElementRef.current.volume = 1.0;
                    remoteAudioElementRef.current.muted = false;
                    
                    // Verify stream is attached
                    if (!remoteAudioElementRef.current.srcObject) {
                        console.warn('⚠️ No srcObject, reattaching stream...');
                        remoteAudioElementRef.current.srcObject = audioStream;
                    }

                    // Check if tracks are live
                    const stream = remoteAudioElementRef.current.srcObject as MediaStream;
                    if (stream) {
                        const tracks = stream.getAudioTracks();
                        const liveTracks = tracks.filter(t => t.readyState === 'live');
                        console.log(`📊 Remote audio tracks: ${tracks.length} total, ${liveTracks.length} live`);
                        
                        if (liveTracks.length === 0) {
                            console.warn('⚠️ No live remote audio tracks, waiting...');
                            setTimeout(() => playAudio(), 500);
                            return;
                        }
                    }
                    
                    console.log('🎵 Attempting to play remote audio...');
                    const playPromise = remoteAudioElementRef.current.play();
                    
                    if (playPromise !== undefined) {
                        await playPromise;
                        console.log('✅ ✅ ✅ REMOTE AUDIO IS NOW PLAYING! ✅ ✅ ✅');
                        console.log(`   Volume: ${(remoteAudioElementRef.current.volume * 100).toFixed(0)}%`);
                        console.log(`   Muted: ${remoteAudioElementRef.current.muted}`);
                        console.log(`   Paused: ${remoteAudioElementRef.current.paused}`);
                        console.log(`   ReadyState: ${remoteAudioElementRef.current.readyState}`);
                    }
                } catch (err: any) {
                    console.error('❌ Audio play error:', err.name, err.message);
                    if (err.name === 'NotAllowedError' || err.name === 'NotAllowedError') {
                        console.warn('⚠️ Audio play blocked - user interaction required');
                        // Create a visible button to enable audio
                        const enableAudioBtn = document.createElement('button');
                        enableAudioBtn.textContent = '🔊 Click to Enable Audio';
                        enableAudioBtn.style.cssText = `
                            position: fixed;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            padding: 15px 30px;
                            font-size: 16px;
                            background: #4caf50;
                            color: white;
                            border: none;
                            border-radius: 8px;
                            cursor: pointer;
                            z-index: 10000;
                            box-shadow: 0 4px 8px rgba(0,0,0,0.3);
                        `;
                        enableAudioBtn.onclick = async () => {
                            try {
                                if (remoteAudioElementRef.current) {
                                    await remoteAudioElementRef.current.play();
                                    console.log('✅ Audio enabled via button click');
                                }
                            } catch (retryErr) {
                                console.error('Still failed:', retryErr);
                            }
                            enableAudioBtn.remove();
                        };
                        document.body.appendChild(enableAudioBtn);
                    } else {
                        // Retry after a delay
                        setTimeout(() => playAudio(), 1000);
                    }
                }
            };

            // Try to play after a short delay to ensure stream is ready
            setTimeout(() => {
                playAudio();
            }, 500);

            // Also try to play on user interaction (multiple attempts)
            let clickAttempts = 0;
            const maxClickAttempts = 3;
            const clickHandler = () => {
                clickAttempts++;
                if (remoteAudioElementRef.current && remoteAudioElementRef.current.paused && clickAttempts <= maxClickAttempts) {
                    console.log(`🖱️ User interaction detected (attempt ${clickAttempts}/${maxClickAttempts})`);
                    playAudio();
                }
            };
            document.addEventListener('click', clickHandler);
            document.addEventListener('touchstart', clickHandler);
        }
    };

    const startCall = async () => {
        if (isStartingCallRef.current || isCalling || isCallConnected) return;

        const metaPhoneNumber = findPersonDetail("phone")
        const phoneNumberId = callingWabaDetails?.phone_number_id

        // if (!metaPhoneNumber) {
        //     console.error('❌ startCall: metaPhoneNumber not found');
        //     showError('User phone number not available')
        //     return;
        // }
        if (!phoneNumberId) {
            console.error('❌ startCall: phone_number_id not found');
            showError('WhatsApp phone_number_id not available')
            return;
        }

        console.log('🚀 startCall triggered with:', { metaPhoneNumber, phoneNumberId });

        isStartingCallRef.current = true;
        setIsStartingCall(true);

        if (phoneNumberId) {
            try {
                if (!localStreamRef.current && isMicPermissionGranted()) {
                    const acquired = await acquireMicrophoneAccess();
                    if (!acquired) return;
                }

                // Create peer connection
                const peerConnection = await createPeerConnection();

                // Create SDP offer
                console.log('📤 Creating WebRTC offer...');
                console.log(`📊 Initial states:`);
                console.log(`   signalingState: ${peerConnection.signalingState}`);
                console.log(`   connectionState: ${peerConnection.connectionState}`);
                console.log(`   iceConnectionState: ${peerConnection.iceConnectionState}`);
                
                const offer = await peerConnection.createOffer();
                console.log(`✅ Offer created (${offer.sdp?.length || 0} bytes)`);
                
                await peerConnection.setLocalDescription(offer);
                console.log(`✅ Local description set`);
                console.log(`📊 States after setLocalDescription:`);
                console.log(`   signalingState: ${peerConnection.signalingState} (should be 'have-local-offer')`);
                console.log(`   connectionState: ${peerConnection.connectionState}`);
                console.log(`   iceConnectionState: ${peerConnection.iceConnectionState}`);

                // Wait for ICE gathering (proceed with partial candidates on mobile timeout)
                console.log(`🧊 Waiting for ICE gathering (current state: ${peerConnection.iceGatheringState})...`);
                await waitForIceGatheringComplete(peerConnection, { label: 'Outbound call' });
                
                console.log(`📊 States after ICE gathering:`);
                console.log(`   signalingState: ${peerConnection.signalingState}`);
                console.log(`   iceGatheringState: ${peerConnection.iceGatheringState}`);

                console.log('Initiating call with WebRTC...');
                
                // Send request to server with browser SDP offer
                const payload = {
                    phone_number: metaPhoneNumber,
                    phone_number_id: callingWabaDetails?.phone_number_id || "",
                    is_ai_call: false,
                    browser_sdp_offer: peerConnection.localDescription?.sdp || "",
                    thread_id: currentActiveChatbotThread?.chatbot_user_id || ""
                }
                setIsCalling(true);
                const res = await agent.initialCallRequest.post(payload);
                
                if (res?.status) {
                    console.log('✅ Call initiated successfully!');

                    setVoiceCallId(res?.data?.call_id);

                    // Set server SDP answer as remote description
                    if (res.data?.server_sdp_answer) {
                        console.log(`📥 Setting server SDP answer (${res.data.server_sdp_answer.length} bytes)`);
                        console.log(`📊 States BEFORE setting remote description:`);
                        console.log(`   signalingState: ${peerConnection.signalingState}`);
                        console.log(`   connectionState: ${peerConnection.connectionState}`);
                        console.log(`   iceConnectionState: ${peerConnection.iceConnectionState}`);
                        
                        try {
                            await peerConnection.setRemoteDescription({
                                type: 'answer',
                                sdp: res.data.server_sdp_answer
                            });
                            console.log('✅ Server SDP answer applied successfully');
                            
                            // Check states immediately after setting remote description
                            console.log(`📊 States AFTER setting remote description:`);
                            console.log(`   signalingState: ${peerConnection.signalingState} (should be 'stable')`);
                            console.log(`   connectionState: ${peerConnection.connectionState}`);
                            console.log(`   iceConnectionState: ${peerConnection.iceConnectionState} (should start changing from 'new')`);
                            console.log(`   iceGatheringState: ${peerConnection.iceGatheringState}`);
                            
                            // Verify signaling state progressed
                            if (peerConnection.signalingState === 'stable') {
                                console.log('✅ Signaling state is stable - ICE should start now');
                            } else {
                                console.warn(`⚠️ Signaling state is ${peerConnection.signalingState}, expected 'stable'`);
                            }
                            
                            // Wait a bit for ICE to start processing
                            await new Promise(resolve => setTimeout(resolve, 500));
                            
                            console.log(`📊 States after 500ms wait:`);
                            console.log(`   signalingState: ${peerConnection.signalingState}`);
                            console.log(`   connectionState: ${peerConnection.connectionState}`);
                            console.log(`   iceConnectionState: ${peerConnection.iceConnectionState}`);
                            
                        } catch (sdpError: any) {
                            console.error('❌ Error setting remote description:', sdpError);
                            console.error('   Error name:', sdpError.name);
                            console.error('   Error message:', sdpError.message);
                            throw sdpError;
                        }
                        
                        // If already connected, trigger the handler
                        if (peerConnection.connectionState === 'connected' || peerConnection.iceConnectionState === 'connected') {
                            console.log('✅ Already connected, triggering connection handler');
                            isCallConnectedRef.current = true;

                            // Now, this things is handle by socket response

                            setIsCalling(true);
                            setIsCallConnected(true);
                            startCallTimer();
                        } else {
                            // Check if signaling state is correct - if not, connection won't progress
                            if (peerConnection.signalingState !== 'stable') {
                                console.error(`❌ CRITICAL: Signaling state is ${peerConnection.signalingState}, not 'stable'!`);
                                console.error('   Connection cannot progress without stable signaling state.');
                                console.error('   This usually means the SDP answer is invalid or incompatible.');
                                
                                // Try to get more info about the SDP
                                if (res.data?.server_sdp_answer) {
                                    const sdpLines = res.data.server_sdp_answer.split('\n');
                                    console.log('📄 SDP Answer preview (first 20 lines):');
                                    sdpLines.slice(0, 20).forEach((line: string, idx: number) => {
                                        console.log(`   ${idx + 1}: ${line}`);
                                    });
                                }
                            }
                            
                            // Set up a periodic check as fallback (in case events don't fire)
                            let checkCount = 0;
                            const maxChecks = 30;
                            stateCheckIntervalRef.current = setInterval(() => {
                                checkCount++;
                                const connState = peerConnection.connectionState;
                                const iceState = peerConnection.iceConnectionState;
                                const sigState = peerConnection.signalingState;

                                console.log(`🔄 State check ${checkCount}/${maxChecks}:`);
                                console.log(`   signalingState: ${sigState}`);
                                console.log(`   connectionState: ${connState}`);
                                console.log(`   iceConnectionState: ${iceState}`);

                                if (sigState !== 'stable' && checkCount === 1) {
                                    console.error(`❌ Signaling state is ${sigState} - connection cannot progress!`);
                                }

                                if (connState === 'connected' || iceState === 'connected') {
                                    console.log('✅ Connection detected via periodic check!');
                                    if (!isCallConnectedRef.current) {
                                        isCallConnectedRef.current = true;
                                        setIsCalling(true);
                                        setIsCallConnected(true);
                                        startCallTimer();
                                    }
                                    if (stateCheckIntervalRef.current) {
                                        clearInterval(stateCheckIntervalRef.current);
                                        stateCheckIntervalRef.current = null;
                                    }
                                } else if (
                                    connState === 'failed' ||
                                    connState === 'closed' ||
                                    iceState === 'failed' ||
                                    iceState === 'closed' ||
                                    checkCount >= maxChecks
                                ) {
                                    if (checkCount >= maxChecks) {
                                        console.error('❌ Connection check timeout - states did not progress');
                                        console.error(`   Final signalingState: ${sigState}`);
                                        console.error(`   Final connectionState: ${connState}`);
                                        console.error(`   Final iceConnectionState: ${iceState}`);
                                    }
                                    if (stateCheckIntervalRef.current) {
                                        clearInterval(stateCheckIntervalRef.current);
                                        stateCheckIntervalRef.current = null;
                                    }
                                }
                            }, 1000);
                        }
                    } else {
                        console.warn('⚠️ No server SDP answer in response');
                    }
                } else {
                    setVoiceCallId("");
                    setIsCalling(false)
                    throw new Error(res?.error || 'Failed to initiate call');
                }
                
            } catch (err: any) {
                console.error('Failed to initiate call:', err);
                showError(err?.message ?? "Failed to initiate call")
                setIsCalling(false);
                
                // Cleanup on error
                cleanupWebRTC();
            } finally {
                // Unlock so retries work if start failed; while calling, Start Call button is hidden
                isStartingCallRef.current = false;
                setIsStartingCall(false);
            }
        }
    };

    const isMicPermissionDenied = () => micPermission === 'denied';
    const isMicPermissionGranted = () => micPermission === 'granted';

    const getMicPermissionStatus = () => {
        if (isMicPermissionDenied()) {
            return {
                icon: '❌',
                text: 'Microphone access denied',
                textClass: `${styles.micPermissionGlobalStyle} ${styles.permissionDeniedStyles}`,
                sentence: 'Microphone access is required to initiate the call. Please enable microphone access from your system settings.',
                sentenceClass: `${styles.permissionErrorText} ${styles.permissionText}`,
            };
        }
        return {
            icon: '🎤',
            text: 'Click "Allow Microphone" to enable audio',
            textClass: `${styles.micPermissionGlobalStyle} ${styles.permissionGrantStyles}`,
            sentence: 'Microphone access is required to initiate the call. Please click on "Allow Microphone" to grant permission.',
            sentenceClass: `${styles.permissionAccessText} ${styles.permissionText}`,
        };
    };

    const micStatus = !isMicPermissionGranted() ? getMicPermissionStatus() : null;

    const isPreCallOutgoing = !isCalling && !isCallConnected;

    const handleTopClose = () => {
        if (isCalling || isCallConnected) {
            endUserPhoneCall();
            return;
        }
        setFlagVoiceCallPopup(false);
    };

    const renderTimerChip = () => (
        <div className={styles.whatsappCallTimerChip}>
            <span className={styles.whatsappCallTimerDot} aria-hidden />
            <span>{formatCallDuration(callDuration)}</span>
        </div>
    );

    const renderCallerAvatar = () => {
        if (isPreCallOutgoing) {
            return renderPulsingCallerAvatar();
        }

        return (
            <div className={styles.inboundCallerAvatarStyle}>
                {shouldShowPersonIcon() ? (
                    <PersonIcon sx={{ color: '#fff', fontSize: 40 }} />
                ) : (
                    getCallerInitial()
                )}
            </div>
        );
    };

    const renderCallerIdentity = () => (
        <>
            <div className={`${styles.inboundCallStaggerItem} ${styles.inboundCallStagger3}`}>
                {renderCallerAvatar()}
            </div>
            <div className={`${styles.inboundCallerNameStyle} ${styles.inboundCallStaggerItem} ${styles.inboundCallStagger4}`}>{getCallerDisplayName()}</div>
            {getFormattedCallerPhone() && getCallerDisplayName() !== getFormattedCallerPhone() && (
                <div className={`${styles.inboundCallerPhoneStyle} ${styles.inboundCallStaggerItem} ${styles.inboundCallStagger4}`}>{getFormattedCallerPhone()}</div>
            )}
            {isCallConnected && (
                <div className={`${styles.inboundCallStaggerItem} ${styles.inboundCallStagger4}`}>
                    {renderTimerChip()}
                </div>
            )}
            {getCallingFromLabel() && (
                <span className={`${styles.inboundWabaInfoStyle} ${styles.inboundCallStaggerItem} ${styles.inboundCallStagger5}`}>
                    {getCallingFromLabel()}
                </span>
            )}
        </>
    );

    const renderPopupHeader = () => (
        <Grid item xs={12} className={`${styles.whatsappCallTopBar} ${styles.inboundCallStaggerItem} ${styles.inboundCallStagger1}`}>
            {!isCalling && !isCallConnected &&
                <button type="button" className={styles.whatsappCallCloseBtn} onClick={handleTopClose} aria-label="Close">
                    <CloseIcon />
                </button>
            }
            <div className={styles.whatsappCallBrandRow}>
                <img alt="whatsapp" src={whatsappIcon} height={20} width={20} className={globalStyles.displayFlexStyle} />
                <span className={styles.whatsappCallBrandLabel}>WhatsApp</span>
            </div>
            <div className={styles.whatsappCallTitleStyle}>{getPopupTitle()}</div>
        </Grid>
    );

    const renderCallActionButtons = (showEndCall: boolean) => (
        <Grid item xs={12} className={styles.whatsappCallControlBar}>
            <div className={styles.whatsappCallControlAction}>
                <div
                    className={`${styles.inboundCallActionButtonStyle} ${isMicMuted ? styles.inboundMuteButtonActiveStyle : styles.inboundMuteButtonStyle}`}
                    onClick={toggleMicMute}
                >
                    {isMicMuted ? (
                        <MicOffIcon sx={{ fontSize: 26 }} />
                    ) : (
                        <MicIcon sx={{ fontSize: 26 }} />
                    )}
                </div>
                <span className={styles.inboundCallActionLabelStyle}>{isMicMuted ? 'Unmute' : 'Mute'}</span>
            </div>
            {showEndCall && (
                <>
                    <div className={styles.whatsappCallControlDivider} aria-hidden />
                    <div className={styles.whatsappCallControlAction}>
                        <div
                            className={`${styles.inboundCallActionButtonStyle} ${styles.inboundRejectButtonStyle}`}
                            onClick={() => endUserPhoneCall()}
                        >
                            <CallEndIcon sx={{ color: '#fff', fontSize: 28 }} />
                        </div>
                        <span className={styles.inboundCallActionLabelStyle}>End Call</span>
                    </div>
                </>
            )}
        </Grid>
    );

    if (flagAllowedToCall === null) {
        return (
            <Grid item className={`${styles.whatsappCallSurface} ${styles.inboundCallContentEnter}`}>
                <Grid container justifyContent="center" alignItems="center" className={styles.outboundCallLoadingStyle}>
                    <span className={styles.outboundLoadingText}>Preparing voice call...</span>
                </Grid>
            </Grid>
        );
    }

    if (!flagAllowedToCall) {
        // null = template list APIs still in flight; keep preparing until we know empty vs has templates
        if (callRequestTemplateList === null) {
            return (
                <Grid item className={`${styles.whatsappCallSurface} ${styles.inboundCallContentEnter}`}>
                    <Grid container justifyContent="center" alignItems="center" className={styles.outboundCallLoadingStyle}>
                        <span className={styles.outboundLoadingText}>Preparing voice call...</span>
                    </Grid>
                </Grid>
            );
        }

        const hasCallRequestTemplates = callRequestTemplateList.length > 0;

        return (
            <Grid item className={`${styles.whatsappCallSurface} ${styles.inboundCallContentEnter}`} paddingY={"0px !important"}>
                <Grid container className={styles.whatsappCallLayout}>
                    {renderPopupHeader()}
                    <Grid item xs={12} className={styles.whatsappCallBody} justifyContent={"center"}>
                        <ReportGmailerrorredIcon className={styles.notAllowedIconStyle} />
                        <div className={styles.outboundNotAllowedText}>
                            User has not granted call permission. Please send a call request permission first.
                        </div>
                        <div className={styles.outboundCallPermissionHint}>
                            {hasCallRequestTemplates
                                ? 'Select a Call Permission Request template below to ask the user for permission.'
                                : 'No Call Permission Request template found. Create one first to send a permission request.'}
                        </div>
                        {hasCallRequestTemplates && (
                            <Grid item xs={12} className={styles.outboundCallPermissionTemplateSelect}>
                                <Autocomplete
                                    options={callRequestTemplateList || []}
                                    value={selectedCallRequestTemplate}
                                    onChange={(_event, newValue) => setSelectedCallRequestTemplate(newValue)}
                                    getOptionLabel={(option) => getCallRequestTemplateName(option)}
                                    isOptionEqualToValue={(option, value) => option?.whatsapp_template_id === value?.whatsapp_template_id}
                                    renderOption={(props, option) => {
                                        const displayCategory = getCallRequestTemplateCategory(option);
                                        return (
                                            <li {...props} key={option.whatsapp_template_id}>
                                                <Grid container alignItems="center" justifyContent="space-between" gap={1} wrap="nowrap">
                                                    <span className={styles.outboundCallPermissionTemplateName}>
                                                        {getCallRequestTemplateName(option)}
                                                    </span>
                                                    <span
                                                        style={{
                                                            backgroundColor: templateTypeColor(option)?.backgroundColor,
                                                            color: templateTypeColor(option)?.color,
                                                        }}
                                                        className={`${textstyles.templateTypeStyle} ${textstyles.templateTypeStyleWidthAuto}`}
                                                    >
                                                        {displayCategory}
                                                    </span>
                                                </Grid>
                                            </li>
                                        );
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select template"
                                            placeholder="Choose a call permission template"
                                            size="small"
                                        />
                                    )}
                                />
                            </Grid>
                        )}
                        <Grid container justifyContent="center" alignItems="center" gap={2} sx={{ mt: 3 }}>
                            <Grid item>
                                <GlobalButton
                                    buttonText="Cancel"
                                    className="borderedButtonStyle"
                                    sx={{ minWidth: '140px', fontSize: breakPoints.largeScreen ? '13px !important' : '' }}
                                    onClick={() => setFlagVoiceCallPopup(false)}
                                />
                            </Grid>
                            <Grid item>
                                {hasCallRequestTemplates ? (
                                    <GlobalButton
                                        buttonText="Ask Permission"
                                        className="primaryButtonStyle"
                                        sx={{ minWidth: '140px' }}
                                        disabled={!selectedCallRequestTemplate}
                                        onClick={() => askPermissionClick()}
                                    />
                                ) : (
                                    <GlobalButton
                                        buttonText="Create Template"
                                        className="primaryButtonStyle"
                                        sx={{ minWidth: '140px' }}
                                        onClick={() => handleCreateCallRequestTemplateClick()}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid item className={`${styles.whatsappCallSurface} ${styles.inboundCallContentEnter}`} paddingTop={"0px !important"}>
            <Grid container className={styles.whatsappCallLayout}>
                {renderPopupHeader()}

                <Grid item xs={12} className={styles.whatsappCallBody}>
                    {isCallConnected ? (
                        renderCallerIdentity()
                    ) : isCalling ? (
                        <>
                            {/* <span className={`${styles.outboundCallingBadgeStyle} ${styles.inboundCallStaggerItem} ${styles.inboundCallStagger2}`}>Calling...</span> */}
                            {renderCallerIdentity()}
                            <div className={`${styles.outboundCallingHintStyle} ${styles.inboundCallStaggerItem} ${styles.inboundCallStagger5}`}>
                                Please wait while we connect your call with {getCallerDisplayName()}.
                            </div>
                        </>
                    ) : (
                        <>
                            <span className={`${styles.outboundReadyBadgeStyle} ${styles.inboundCallStaggerItem} ${styles.inboundCallStagger2}`}>Ready to call</span>
                            {renderCallerIdentity()}

                            {!isCheckingMicPermission && (
                                <>
                                    {!isMicPermissionGranted() && micStatus && (
                                        <>
                                            <Grid container className={`${micStatus.textClass} ${styles.inboundCallStaggerItem} ${styles.inboundCallStagger5}`} sx={{ width: '100%', mt: 1 }}>
                                                <Grid item>{micStatus.icon}</Grid>
                                                <Grid item className={styles.micAccessFontStyle}>{micStatus.text}</Grid>
                                            </Grid>
                                            <div className={`${micStatus.sentenceClass} ${styles.inboundCallStaggerItem} ${styles.inboundCallStagger5}`}>{micStatus.sentence}</div>
                                            <GlobalButton
                                                buttonText={isRequestingMic ? 'Requesting...' : isMicPermissionDenied() ? 'Retry Microphone' : 'Allow Microphone'}
                                                className={isMicPermissionDenied() ? 'whatsappButtonStyle' : 'primaryButtonStyle'}
                                                sx={{ minWidth: '180px', mt: 1 }}
                                                disabled={isRequestingMic}
                                                onClick={() => requestMicrophone()}
                                            />
                                        </>
                                    )}

                                    {isMicPermissionGranted() && (
                                        <GlobalButton
                                            buttonText={isStartingCall ? 'Starting...' : 'Start Call'}
                                            className="whatsappButtonStyle"
                                            sx={{ minWidth: '180px', height: '44px', mt: 2, mb: 1 }}
                                            disabled={isStartingCall || isCalling}
                                            onClick={() => startCall()}
                                        />
                                    )}
                                </>
                            )}
                        </>
                    )}
                </Grid>

                {(isCalling || isCallConnected) && renderCallActionButtons(isCallConnected)}
            </Grid>
        </Grid>
    );
}

export default VoiceAIPopup
